import type { StoreAdminInfo } from '@onboarding/domain/value-objects';
import type { StoreAdminInfoDto } from '@onboarding/application/dtos';

/**
 * Maps a StoreAdminInfo domain value object to the view DTO consumed by presentation.
 *
 * @param info - Domain value object
 * @returns Plain DTO for the presentation layer
 */
export const mapStoreAdminInfoToDto = (info: StoreAdminInfo): StoreAdminInfoDto => ({
  storeName: info.storeName,
  legalName: info.legalName,
  rfc: info.rfc,
  fiscalAddress: info.fiscalAddress,
});
